// extracted by mini-css-extract-plugin
module.exports = {"dish-preference":"dish-preference___2ioM3","category-item":"category-item___23_Zm","optionLinkWrapper":"optionLinkWrapper___rxlC0","optionLink":"optionLink___HXSh-"};